import { render } from "./UsefulLinks.vue?vue&type=template&id=c2d0fe5e&scoped=true"
import script from "./UsefulLinks.vue?vue&type=script&lang=js"
export * from "./UsefulLinks.vue?vue&type=script&lang=js"

import "./UsefulLinks.vue?vue&type=style&index=0&id=c2d0fe5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d0fe5e"]])

export default __exports__